import TashbeekModule from "./store";
import store from "@/store";

export default [
  {
    path: "/tashbeek",
    redirect: "/tashbeek/benfit",
    beforeEnter(to, _, next) {
      if (!store.hasModule("Tashbeek"))
        store.registerModule("Tashbeek", TashbeekModule);
      next();
    },
    component: () => import("./moduleLayout.vue"),
    children: [
      {
        path: "benfit",
        name: "tashbeek-benfit",
        component: () => import("./pages/benfit/index.vue"),
        meta: {
          pageTitle: "استفد",
          slug: "ngo_assists",
          instructionsSlug: "take",
          breadcrumb: [
            {
              text: "تشبيك",
              active: true,
            },
            {
              text: "استفد",
              active: true,
            },
          ],
        },
      },
      {
        path: "give",
        name: "tashbeek-give",
        component: () => import("./pages/give/index.vue"),
        meta: {
          pageTitle: "امنح",
          slug: "ngo_assists",
          instructionsSlug: "give",
          breadcrumb: [
            {
              text: "تشبيك",
              active: true,
            },
            {
              text: "امنح",
              active: true,
            },
          ],
        },
      },
      {
        path: "tashbeek-management",
        name: "tashbeek-management",
        component: () =>
          import("../tashbeek/pages/tashbeek-management/index.vue"),
        meta: {
          pageTitle: "إدارة واجهات تشبيك",
          slug: "ngo_assists_management",
          instructionsSlug: "ngo-assists-management",
          breadcrumb: [
            {
              text: "تشبيك ",
              active: true,
            },
            {
              text: "إدارة واجهات تشبيك",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
